import { useState } from "react";
import CustomDropdown from "../../../Components/Dropdown/CustomDropdown";
import { DataFromAPI4, item_code } from "../../../Data/testData";
import { selectedComponent, bomSelectComponentItemCode } from "../../../Data/BomMaintainanceData";
import PageHeader from "../../../Layout/PageHeader";
import CustomizableTableForAddAndEdit from "../../../Components/Tables/CustomizableTableForAddAndEdit";
import FormButton from "../../../Components/Buttons/FormButton";
import { useNavigate } from "react-router-dom";
import InputFiled from "../../../Components/FormTag/InputFiled";
import { bomBasicInformationType } from "./Bom.type";
import { useForm } from "react-hook-form";

const BomMaintenanceCreate = () => {
  const pageName = "Create Kit";
  const { register } = useForm<bomBasicInformationType>({
    defaultValues: new bomBasicInformationType(),
  });

  const [selectedDescription, setSelectedDescription] = useState<string>("");
  const [selectedItemCode, setSelectedItemCode] = useState<string>("");
  const [isItemSelected, setIsItemSelected] = useState(false);

  const [selectedComponentItem, setSelectedComponentItem] = useState<any>(null);
  const [selectedComponentDescription, setSelectedComponentDescription] = useState<string>("");
  const [selectedComponentType, setSelectedComponentType] = useState<string>("");

  const handleTopSelect = (item: Record<string, any>) => {
    if (!item?.item) {
      console.error("Invalid selection.");
      return;
    }

    setSelectedItemCode(item.item);
    setSelectedDescription(item.description || "_");
    setIsItemSelected(true);
  };

  const handleComponentSelect = (item: Record<string, any>) => {
    if (!item?.item) {
      console.error("Invalid component selection.");
      return;
    }

    setSelectedComponentItem(item);
    setSelectedComponentDescription(item.description || "_");
    setSelectedComponentType(item.itemtype || "_");
  };

  const columnsConfig = [
    { columnName: "Item #", selector: "item" },
    { columnName: "Description", selector: "description" },
  ];

  const columnsConfig2 = [
    { columnName: "Item #", selector: "item" },
    { columnName: "Description", selector: "description" },
    { columnName: "Item Type", selector: "itemtype" },
  ];

  const columns = [
    {
      key: "itemCode",
      label: "Item Code",
      inputType: (
        <span className="customDropdown customCreateDropDownWidth">
          <CustomDropdown
            customClassName="item-code p-0 "
            data={bomSelectComponentItemCode}
            selectableColumns={columnsConfig2}
            handleSelect={handleComponentSelect} // Use the component-specific handler
          />
        </span>
      ),
      disable: true,
    },
    {
      key: "itemDescription",
      label: "Item Description",
      disable: true,
      inputType: <div>{selectedComponentDescription || "_"}</div>,
    },
    {
      key: "itemtype",
      label: "Item Type",
      disable: true,
      inputType: <div>{selectedComponentType || "_"}</div>,
    },
    {
      key: "Qty",
      label: "Qty",
      disable: true,
      inputType: (
        <span className="customDropdown">
          <InputFiled
            type="text"
            tabIndex={1}
            register={register}
            name="Qty"
            required={true}
            className="no-border-on-hover bg-transparent"
            placeholder="_"
          />
        </span>
      ),
      customStyles: { width: "80px" },
    },
  ];

  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/inventory/assembly/kitting");
  };

  return (
    <>
      <PageHeader
        addUrl="/inventory/assembly/kitting/create"
        listUrl="/inventory/assembly/kitting"
        viewType={true}
        isHistoryEnabled={true}
      />
      <div className="clearfix"></div>
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="my-2 bg-white rounded py-3 px-3 test h-100">
        <div className="mb-2 mt-1 px-4 bg-white rounded">
          <div className="d-flex flex-wrap">
            <div className=" col-3">
              <div className="text-secondary ">
                <small className="fs-14">Item Code</small>
              </div>

              {!isItemSelected ? (
                <CustomDropdown
                  customClassName="item-code p-0 customDropDownMenuWidth"
                  data={item_code}
                  selectableColumns={columnsConfig}
                  handleSelect={handleTopSelect}
                />
              ) : (
                <div className="fs-15">{selectedItemCode}</div>
              )}
            </div>
            <div className=" col-3">
              <div className="text-secondary ">
                <small className="fs-14">Item Description</small>
              </div>
              <div className="fs-15">{selectedDescription || "_"}</div>
            </div>
            <div className="col-3">
              <div className="text-secondary ">
                <small className="fs-14">Item Type</small>
              </div>
              <div className="fs-15">Assembly</div>
            </div>
          </div>
        </div>
      </div>
      {isItemSelected && (
        <>
          <h6 className="text-start mb-1">Select Component</h6>

          <div className="my-2 bg-white rounded p-4 h-100 CustomizedTable">

            <CustomizableTableForAddAndEdit
              columns={columns}
              initialData={selectedComponent}
              dataFromAPI={DataFromAPI4}
              filterColumn="itemCode"
            />
          </div>
          <div className="mt-auto bg-white rounded py-3">
            <div className="d-flex flex-row-reverse">
              <FormButton
                tabIndex={25}
                className="sph-btn me-4"
                handleClick={handleBack}
              >
                Submit
              </FormButton>
              <FormButton
                tabIndex={26}
                className="sph-btn sph-shift me-4"
                handleClick={handleBack}
              >
                Cancel
              </FormButton>
            </div>
          </div>
        </>
      )}
      <div className="inbound-CheckIn-Table-Main-Div"></div>
    </>
  );
};

export default BomMaintenanceCreate;
